import React, { useEffect } from 'react';
import './index.module.less';
import { loadAnimation } from '@views/components/LottieCreator';
import animation1 from './lottie/call/data.json';
import animation2 from './lottie/call2/data.json';
import xueshengzheng1 from './lottie/call/images/xueshengzheng.png';
import xueshengzheng2 from './lottie/call2/images/xueshengzheng.png';

const AnimationConfig = {
  '1': { json: animation1, image: xueshengzheng1 },
  '2': { json: animation2, image: xueshengzheng2 },
};
interface IAnimationViewProps {
  type?: '1' | '2',
}
const AnimationView = (props: IAnimationViewProps) => {
  const { type = '1' } = props;
  useEffect(() => {
    const currAnimationConfig = AnimationConfig[type] || AnimationConfig['1'];
    const animation = loadAnimation({
      loop: true,
      autoplay: false,
      container: document.getElementById('lottie'),
      animationData: currAnimationConfig.json,
    },[currAnimationConfig.image]);
    animation.play();
  // eslint-disable-next-line
  },[]);
  
  return (
    <div styleName="container">
      <div className='flex flex-center' styleName='animation-container' id='lottie'></div>
    </div>
  )
}

export default AnimationView;
